import Badge from './Badge.vue';

export default Badge;



// WEBPACK FOOTER //
// ./src/components/parts/competences/card/components/badge/index.ts